import { createElement } from 'react';

import { Icons } from '../../Foundation/Icons';

export const renderIconElement = (icon?: string): JSX.Element | undefined =>
  icon ? createElement(Icons[icon]) : undefined;
